import styled from 'styled-components/macro';

export const ScInputPromo = styled.div`
  position: relative;
  height: fit-content;
  margin-top: 16px;
  .form-group {
    &__row {
      display: grid;
      grid-template-columns: 1fr 128px;
      gap: 8px;
    }
  }
`;
